import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs } from '../../../../components/Tabs';
import { DashboardPanel } from './DashboardPanel';
import { DetectionToolPanel } from './DetectionToolPanel';

export const AI_DETECTION_TABS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'detect', label: 'Detection Tool' },
] as const;

export type AiDetectionTabId = (typeof AI_DETECTION_TABS)[number]['id'];

/** `?tab=` value → tab. The dashboard is the default for anything else. */
export function parseAiDetectionTab(value: string | null): AiDetectionTabId {
  return AI_DETECTION_TABS.find((tab) => tab.id === value)?.id ?? 'dashboard';
}

export function AiDetectionDashboardTool({ mobileNavTrigger }: { mobileNavTrigger?: React.ReactNode }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseAiDetectionTab(searchParams.get('tab'));

  const selectTab = (id: string) => {
    setSearchParams(() => {
      const next = new URLSearchParams();
      if (id !== 'dashboard') next.set('tab', id);
      return next;
    }, { replace: true });
  };

  return (
    <section className="min-w-0">
      <div className="flex items-start justify-between gap-3">
        <h1 className="min-w-0 text-xl font-bold text-gray-900 sm:text-2xl">AI Detection</h1>
        {mobileNavTrigger}
      </div>

      <div className="mt-4">
        <Tabs tabs={[...AI_DETECTION_TABS]} activeId={tab} onChange={selectTab} />
      </div>

      {/* Both panels stay mounted so pasted text and results survive a tab switch. */}
      <div hidden={tab !== 'dashboard'}>
        <DashboardPanel />
      </div>
      <div hidden={tab !== 'detect'}>
        <DetectionToolPanel />
      </div>
    </section>
  );
}
